import EmblaCarousel from 'embla-carousel';

(function (Drupal) {
  Drupal.behaviors.emblaTabs = {
    attach(context) {
      const carousels = once('embla-init', '.embla', context);

      carousels.forEach((emblaNode) => {
        const viewport = emblaNode.querySelector('.embla__viewport');
        const prevBtn = emblaNode.querySelector('.embla__prev');
        const nextBtn = emblaNode.querySelector('.embla__next');

        const embla = EmblaCarousel(viewport, { loop: false });

        if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
        if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

        // Store instance for reInit
        emblaNode.__emblaInstance = embla;
      });

      // Re-init any embla inside newly shown tab pane
      once('embla-tab-handler', '[data-bs-toggle="tab"]', context).forEach((tab) => {
        tab.addEventListener('shown.bs.tab', () => {
          document.querySelectorAll('.embla').forEach((emblaNode) => {
            if (emblaNode.offsetParent !== null && emblaNode.__emblaInstance) {
              emblaNode.__emblaInstance.reInit();
            }
          });
        });
      });
    }
  };
})(Drupal);
